export default __webpack_public_path__ + "static/media/Growth.96501f1c.svg";